/**
 * 接口合并导出
 */
export * from "./apis/api-abnormal.js";
export * from "./apis/api-alarm.js";
export * from "./apis/api-basic.js";
export * from "./apis/api-check-project.js";
export * from "./apis/api-common.js";
export * from "./apis/api-edm-document.js";
export * from "./apis/api-plm-document.js";
export * from "./apis/api-inspect-work-order.js";
export * from "./apis/api-inspect-batch.js";
export * from "./apis/api-process.js";
export * from "./apis/api-prodcution-setting.js";
export * from "./apis/api-station.js";
export * from "./apis/api-system-user.js";
export * from "./apis/api-work-order.js";
export * from "./apis/api-deivce-info.js";
export * from "./apis/api-mould.js";
export * from "./apis/api-store-requisition.js";
export * from "./apis/api-massProduction.js";
export * from "./apis/api-allInspections.js";
export * from "./apis/api-btnSetting.js";
export * from "./apis/api-materiel.js";
export * from "./apis/api-process-flow-order.js";
export * from "./apis/api-assembly-line.js";
export * from "./apis/api-inspect-craft.js";
export * from "./apis/api-work-report-record.js";
export * from "./apis/api-check-sl.js";
export * from "./apis/api-progressReport.js";
export * from "./apis/api-inspect-task.js";
export * from "./apis/api-workshop.js";
export * from "./apis/api-APImanage.js";
export * from "./apis/api-menu-module.js";
export * from "./apis/api-work-dy.js";
